import MicIcon from '@mui/icons-material/Mic';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import {
  ArrayInput, AutocompleteInput, Button, ReferenceInput, SimpleFormIterator, required,
} from 'react-admin';
import { useFormContext } from 'react-hook-form';

import AlbumArtistCreate from './Create/AlbumArtistCreate';

function AlbumArtistSection() {
  const [artistPopupOpen, setArtistPopupOpen] = useState(false);
  const { getValues, setValue } = useFormContext();

  const handleArtistSave = (artistId: string) => {
    const currentArtists = getValues('DiscographyAlbumArtists') || [];

    // Add the new artist to the array
    setValue('DiscographyAlbumArtists', [
      ...currentArtists,
      {
        DiscographyArtistIdentifier: artistId,
      },
    ], { shouldDirty: true });

    setArtistPopupOpen(false);
  };

  return (
    <Box
      mb={3} width={{ xs: '100%', md: '70%' }}
      p={2} border={1}
      borderRadius={2} borderColor='grey.400'
    >
      <Typography
        variant='h6' gutterBottom
        display='flex' alignItems='center'
        gap={1}
      >
        <MicIcon />
        Artists
      </Typography>
      <ArrayInput source='DiscographyAlbumArtists' label=''>
        <SimpleFormIterator
          disableReordering
          disableClear
          sx={{
            '& .RaSimpleFormIterator-line': {
              border: 1,
              borderColor: 'grey.300',
              borderRadius: 1,
              padding: 2,
              marginBottom: 2,
            },
            '& > ul > li:last-child': {
              borderBottom: '1px solid',
              borderColor: 'grey.300',
            },
          }}
        >
          <ReferenceInput
            source='DiscographyArtistIdentifier'
            reference='artists'
            sort={{ field: 'Name', order: 'ASC' }}
            perPage={20}
          >
            <AutocompleteInput
              label='Artist'
              optionText='Name'
              optionValue='id'
              filterToQuery={(q) => ({ Name: q })}
              fullWidth
              validate={required()}
            />
          </ReferenceInput>
        </SimpleFormIterator>
      </ArrayInput>
      <Button
        label='Create Artist' onClick={() => setArtistPopupOpen(true)}
        sx={{ mt: 2 }}
      />
      <AlbumArtistCreate
        open={artistPopupOpen}
        onClose={() => setArtistPopupOpen(false)}
        onSave={handleArtistSave}
      />
    </Box>
  );
}

export default AlbumArtistSection;
